import { track, trackOnce } from './funnel';
import { sessionContext } from './session-context';

export type LandingKind = 'start' | 'ip';

/**
 * События конверсионных лендингов.
 *
 * Ровно две ступени. `faq_open`, `table_view` и прочее из макета намеренно НЕ
 * заводятся: при нашем объёме они дадут строки, но не выводы, а таблица
 * `events` и без них примерно на 89% состоит из ботов.
 *
 * ⚠️ Meta `InitiateCheckout` отсюда НЕ отправляется. Он уже уходит в момент
 * создания заказа, с dedup-id и парной серверной отправкой через CAPI; копия
 * на клик по кнопке лендинга разбавила бы единственный сигнал, по которому
 * Meta оптимизирует показы.
 */
export function trackLandingView(lp: LandingKind, lang: string): void {
  /*
   * The landings render OUTSIDE `AppLayout`, which is where `session_start`
   * fires for the rest of the site — so a paid visitor who landed on /start
   * (6.5k people a month) started no session at all, and the top of the
   * conversion funnel simply did not contain them (2026-09-06). Same
   * sessionStorage guard as the app: a visitor who continues into the
   * catalogue does not start a second session there.
   */
  trackOnce('session_start', sessionContext());
  track('lp_viewed', { lp, lang });
}

export function trackLandingCta(lp: LandingKind, lang: string, label: string): void {
  track('lp_cta_clicked', { lp, lang, label });
}
